<template>
  <div class="wrong-analysis">
    <!-- 统计数据区域 - 移到最顶端 -->
    <el-card class="stats-card" v-loading="loading" :body-style="{ padding: '12px' }">
      <div class="stats-content">
        <el-row :gutter="20" class="stats-row">
          <el-col :span="4">
            <div class="stat-item">
              <div class="stat-label">总错题数</div>
              <div class="stat-value">{{ statisticsData.totalWrongCount || 0 }}</div>
            </div>
          </el-col>
          <el-col :span="4">
            <div class="stat-item">
              <div class="stat-label">涉及标签</div>
              <div class="stat-value">{{ statisticsData.involvedTags || 0 }}</div>
            </div>
          </el-col>
          <el-col :span="4">
            <div class="stat-item">
              <div class="stat-label">
                <span>主要错误</span>
                <el-tooltip effect="dark" placement="top" popper-class="difficulty-tooltip">
                  <div slot="content" class="difficulty-tooltip-content">
                    <div class="difficulty-description">
                      <p><strong>1. 算法未掌握</strong>：未掌握核心知识点、算法原理或其适用性；</p>
                      <ul>
                        <li>【学透】深入理解定义、原理、推导、复杂度</li>
                        <li>【对比】区分相似概念，明确应用场景</li>
                        <li>【复习】定期回顾基础知识</li>
                      </ul>
                      <p><strong>2. 思路/逻辑偏差</strong>：思路框架或解题逻辑有缺陷，无法构建正确解题路径；</p>
                      <ul>
                        <li>【拆解】将问题分解，逐个击破</li>
                        <li>【模拟】用小数据手动演算，验证思路</li>
                        <li>【学习】学习他人优秀解法，寻找更优思路</li>
                      </ul>
                      <p><strong>3. 实现/细节错误</strong>：思路正确，但代码细节处理不当，导致程序出错；</p>
                      <ul>
                        <li>【细抠】关注边界、初始化、数据类型、语句逻辑</li>
                        <li>【调试】熟练使用调试器，定位问题</li>
                        <li>【规范】养成良好的编码习惯</li>
                      </ul>
                      <p><strong>4. 效率/复杂度问题</strong>：算法或实现效率低，导致超时 (TLE) 或超内存 (MLE)；</p>
                      <ul>
                        <li>【估算】优先评估算法时间/空间复杂度</li>
                        <li>【优化】学习常用优化技巧（如剪枝、数据结构）</li>
                        <li>【卡点】针对性练习时间/空间敏感题</li>
                      </ul>
                      <p><strong>5. 边界/特殊情况遗漏</strong>：未考虑题目中的特殊数据、极端情况或边界条件；</p>
                      <ul>
                        <li>【预判】思考各种可能的小数据、负数、空集、全同等情况</li>
                        <li>【测试】编写专门测试边界的用例</li>
                        <li>【总结】建立边界条件检查清单</li>
                      </ul>
                      <p><strong>6. 题意理解偏差</strong>：对题目描述、要求、输入输出等理解有误；</p>
                      <ul>
                        <li>【精读】慢读、细读，划出关键词</li>
                        <li>【明确】确认输入输出格式、数据范围、约束条件</li>
                        <li>【举例】用自己的话复述题目</li>
                      </ul>
                      <p><strong>7. 工具/环境问题</strong>：编程语言特性、编译器、IDE、提交系统等非算法本身的细节问题；</p>
                      <ul>
                        <li>【熟悉】了解常用语言特性、库函数用法</li>
                        <li>【检查】留意编译警告，熟悉评测环境</li>
                        <li>【记录】记录常见坑点</li>
                      </ul>
                      <p><strong>8. 心理性错误</strong>：受情绪、心态、比赛压力等因素影响导致的技术失误；</p>
                      <ul>
                        <li>【训练】模拟赛中培养抗压能力</li>
                        <li>【调整】保持积极心态，学会自我鼓励</li>
                        <li>【暂停】遇到困难时，短暂休息，深呼吸</li>
                      </ul>
                      <p><strong>9. 其他/未分类错误</strong>：暂时难以明确归类，或属特定情况的错误；</p>
                      <ul>
                        <li>【分析】尝试将其归入现有分类</li>
                        <li>【记录】暂存，等待进一步研究或求助</li>
                      </ul>
                    </div>
                  </div>
                  <i class="el-icon-question" style="cursor: pointer; margin-left: 4px; font-size: 12px; color: #909399;"></i>
                </el-tooltip>
              </div>
              <el-tooltip :content="statisticsData.mainErrorType || '-'" placement="top">
                <div class="stat-value">{{ statisticsData.mainErrorType || '-' }}</div>
              </el-tooltip>
            </div>
          </el-col>
          <el-col :span="4">
            <div class="stat-item">
              <div class="stat-label">常错标签-1</div>
              <el-tooltip :content="statisticsData.mostWrongTag1 || '-'" placement="top">
                <div class="stat-value">{{ statisticsData.mostWrongTag1 || '-' }}</div>
              </el-tooltip>
            </div>
          </el-col>
          <el-col :span="4">
            <div class="stat-item">
              <div class="stat-label">常错标签-2</div>
              <el-tooltip :content="statisticsData.mostWrongTag2 || '-'" placement="top">
                <div class="stat-value">{{ statisticsData.mostWrongTag2 || '-' }}</div>
              </el-tooltip>
            </div>
          </el-col>
          <el-col :span="4">
            <div class="stat-item">
              <div class="stat-label">常错标签-3</div>
              <el-tooltip :content="statisticsData.mostWrongTag3 || '-'" placement="top">
                <div class="stat-value">{{ statisticsData.mostWrongTag3 || '-' }}</div>
              </el-tooltip>
            </div>
          </el-col>
        </el-row>
      </div>
    </el-card>

    <!-- 查询条件区域 -->
    <el-card class="query-card" v-loading="loading" :body-style="{ padding: '12px' }">
      <div class="query-content">
        <div class="query-form-single-row">
          <div class="query-item">
            <el-select
              v-model="queryForm.tagNames"
              multiple
              filterable
              placeholder="题目标签"
              size="small"
              :clearable="true">
              <el-option
                v-for="tag in tagOptions"
                :key="tag.value"
                :label="tag.label"
                :value="tag.value">
              </el-option>
            </el-select>
          </div>
          <div class="query-item">
            <el-select
              v-model="queryForm.questionLevels"
              multiple
              filterable
              placeholder="题目难度"
              size="small"
              :clearable="true">
              <el-option
                v-for="level in levelOptions"
                :key="level.value"
                :label="level.label"
                :value="level.value">
                <span :style="{ 
                  display: 'inline-block',
                  width: '10px',
                  height: '10px',
                  borderRadius: '2px',
                  marginRight: '6px',
                  backgroundColor: getDifficultyColor(level.value)
                }"></span>
                {{ level.label }}
              </el-option>
            </el-select>
          </div>
          <div class="query-item">
            <el-select
              v-model="queryForm.errorNames"
              multiple
              filterable
              placeholder="错误类型"
              size="small"
              :clearable="true">
              <el-option
                v-for="error in errorOptions"
                :key="error.value"
                :label="error.label"
                :value="error.value">
              </el-option>
            </el-select>
          </div>
          <div class="query-item">
            <el-date-picker
              v-model="queryForm.dateRange"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              size="small"
              :clearable="true"
              :picker-options="{ shortcuts: dateShortcuts }">
            </el-date-picker>
          </div>
          <div class="query-actions">
            <el-button type="primary" size="small" @click="handleQuery" :loading="loading">查询</el-button>
            <el-button size="small" @click="handleReset">重置</el-button>
          </div>
        </div>
      </div>
    </el-card>

    <!-- 桑基图区域 -->
    <el-card class="chart-card" v-loading="chartLoading" :body-style="{ padding: '8px' }">
      <div slot="header" class="card-header">
        <span>{{ chartType ? '时间-难度-错误类型' : '标签-难度-错误类型' }} 流向分析</span>
        <div class="header-controls">
          <el-switch
            v-model="chartType"
            active-text="时间"
            inactive-text="标签"
            @change="handleChartTypeChange">
          </el-switch>
          <el-switch
            v-model="sortEnabled"
            active-text="排序"
            inactive-text="自动"
            @change="handleSortToggle">
          </el-switch>
          <el-switch
            v-model="showLabels"
            active-text="字符"
            inactive-text="隐藏"
            @change="handleLabelToggle">
          </el-switch>
          <el-button 
            size="small" 
            type="primary" 
            @click="downloadChart"
            icon="el-icon-download"
            :loading="downloadLoading"
            class="download-btn">
            下载图片
          </el-button>
        </div>
      </div>
      <div class="chart-content">
        <div class="chart-container" ref="sankeyChart" :style="{ height: chartHeight + 'px' }"></div>
      </div>
    </el-card>
    
    <!-- 固定tooltip组件 -->
    <div 
      v-show="fixedTooltip.visible"
      class="fixed-tooltip"
      :style="{
        left: fixedTooltip.x + 'px',
        top: fixedTooltip.y + 'px'
      }"
      @mousedown="handleTooltipMouseDown"
      @mousemove="handleTooltipMouseMove"
      @mouseup="handleTooltipMouseUp"
      @mouseleave="handleTooltipMouseUp">
      
      <div class="tooltip-header">
        <span class="tooltip-title">{{ fixedTooltip.title }}</span>
        <i class="el-icon-close tooltip-close" @click="closeFixedTooltip"></i>
      </div>
      
      <div class="tooltip-content" v-html="fixedTooltip.content"></div>
      
      <div class="tooltip-drag-hint">
        <i class="el-icon-rank"></i>
        <span>可拖拽移动</span>
      </div>
    </div>

  </div>
</template>

<script>
import * as echarts from 'echarts'
import request from '@/utils/request'

export default {
  name: 'WrongAnalysis',
  data() {
    return {
      loading: false,
      chartLoading: false,
      downloadLoading: false,
      chartHeight: 400,  // 初始值也要调整为新的基础高度
      chartType: false, // false: 标签维度, true: 时间维度
      sortEnabled: false, // true: 启用排序(layoutIterations: 0), false: 自动布局(layoutIterations: 32)
      showLabels: true, // true: 显示节点标签, false: 隐藏标签(点击时显示)
      
      // 查询表单
      queryForm: {
        tagNames: [],
        questionLevels: [],
        errorNames: [],
        dateRange: []
      },
      
      // 下拉选项数据
      tagOptions: [],
      levelOptions: [],
      errorOptions: [],
      
      // 图表实例
      sankeyChart: null,
      
      // 桑基图数据
      sankeyData: {
        nodes: [],
        links: [],
        completePaths: []
      },
      
      // 点击状态管理
      clickedNode: null,
      isClickHighlighted: false,
      
      // 固定tooltip管理
      fixedTooltip: {
        visible: false,
        title: '',
        content: '',
        x: 0,
        y: 0,
        isDragging: false,
        dragOffset: { x: 0, y: 0 }
      },
      
      // 统计数据
      statisticsData: {
        totalWrongCount: 0,
        involvedTags: 0,
        mainErrorType: '-',
        mostWrongTag1: '-',
        mostWrongTag2: '-',
        mostWrongTag3: '-'
      },
      
      // 日期快捷选项 - Element UI 2.x 格式
      dateShortcuts: [
        {
          text: '重置',
          onClick(picker) {
            picker.$emit('pick', null)
          }
        },
        {
          text: '最近一个月',
          onClick(picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
            picker.$emit('pick', [start, end])
          }
        },
        {
          text: '最近三个月',
          onClick(picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
            picker.$emit('pick', [start, end])
          }
        },
        {
          text: '最近半年',
          onClick(picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 180)
            picker.$emit('pick', [start, end])
          }
        },
        {
          text: '最近一年',
          onClick(picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 365)
            picker.$emit('pick', [start, end])
          }
        }
      ],
      
    }
  },
  computed: {
    // 动态计算图表高度 - 时间维度紧凑优化
    dynamicChartHeight() {
      const nodeCount = this.sankeyData.nodes.length
      const layer1Count = this.sankeyData.nodes.filter(n => n.category === 0).length
      const baseHeight = 400  // 降低基础高度，与移动端一致
      
      // 如果是时间维度，根据第一层节点数量特别计算
      let minHeightPerNode = 30  // 稍微减少每节点高度（原35px）
      let extraMargin = 180      // 基础边距
      
      if (this.chartType) {
        // 时间维度：根据第一层节点数量调整
        if (layer1Count > 20) {
          minHeightPerNode = 25  // 节点很多时稍微增加高度
          extraMargin = 200      // 增加边距
        } else if (layer1Count > 10) {
          minHeightPerNode = 24  // 节点多时适中高度
          extraMargin = 190      // 适中边距
        } else {
          minHeightPerNode = 22  // 节点少时紧凑高度
        }
      }
      
      const calculatedHeight = Math.max(baseHeight, nodeCount * minHeightPerNode + extraMargin)
      
      // 设置合理的最大高度限制
      return Math.min(calculatedHeight, 1300)
    }
  },
  watch: {
    dynamicChartHeight(newHeight) {
      this.chartHeight = newHeight
      this.$nextTick(() => {
        if (this.sankeyChart) {
          this.sankeyChart.resize()
        }
      })
    },
    
    // 监听日期范围变化，自动触发查询
    'queryForm.dateRange': {
      handler(newVal, oldVal) {
        // 避免初始化时触发
        if (oldVal !== undefined) {
          this.$nextTick(() => {
            this.handleQuery()
          })
        }
      },
      deep: true
    }
  },
  mounted() {
    this.initChart()
    this.loadOptions()
    this.handleQuery()
    
    // 监听窗口大小变化
    window.addEventListener('resize', this.handleResize)
  },
  beforeDestroy() {
    if (this.sankeyChart) {
      this.sankeyChart.dispose()
    }
    window.removeEventListener('resize', this.handleResize)
  },
  methods: {
    // 去掉节点名称的前缀
    removeNodePrefix(nodeName) {
      if (!nodeName) return nodeName
      return nodeName.replace(/^(时间_|标签_|难度_|错误_|状态_)/, '')
    },
    
    // 初始化图表
    initChart() {
      if (this.sankeyChart) {
        this.sankeyChart.dispose()
      }
      
      this.sankeyChart = echarts.init(this.$refs.sankeyChart)
      this.updateChart()
    },
    
    // 更新图表
    updateChart() {
      if (!this.sankeyChart) return
      
      // 在更新图表前重新分布节点位置（仅当数据存在时）
      if (this.sankeyData && this.sankeyData.nodes && this.sankeyData.nodes.length > 0) {
        // 确保节点已排序
        this.sankeyData.nodes = this.sortAllLayerNodes(this.sankeyData.nodes)
        
        const layer1Nodes = this.sankeyData.nodes.filter(node => node.category === 0)
        const layer2Nodes = this.sankeyData.nodes.filter(node => node.category === 1)
        const layer3Nodes = this.sankeyData.nodes.filter(node => node.category === 2)
        this.redistributeNodePositions(layer1Nodes, layer2Nodes, layer3Nodes)
        
        console.log('排序确认 - updateChart中:')
        console.log('第一层节点:', layer1Nodes.map(n => n.name))
        console.log('第二层节点:', layer2Nodes.map(n => n.name))
        console.log('第三层节点:', layer3Nodes.map(n => n.name))
      }
      
      const option = {
        tooltip: {
          trigger: 'item',
          triggerOn: 'mousemove',
          formatter: function(params) {
            if (params.dataType === 'edge') {
              const sourceName = params.data.source.replace(/^(时间_|标签_|难度_|错误_)/, '')
              const targetName = params.data.target.replace(/^(时间_|标签_|难度_|错误_)/, '')
              // 判断目标节点是否为AC节点
              const isAC = params.data.target === '错误_AC' || targetName === 'AC'
              const label = isAC ? '题目数量' : '错题数量'
              return `${sourceName} → ${targetName}<br/>${label}: ${params.data.value}`
            } else {
              const nodeName = params.data.name.replace(/^(时间_|标签_|难度_|错误_)/, '')
              // 判断是否为AC节点（第三层节点）
              const isAC = params.data.name === '错误_AC' || (params.data.category === 2 && nodeName === 'AC')
              const label = isAC ? '题目数量' : '错题数量'
              return `${nodeName}<br/>${label}: ${params.data.value || 0}`
            }
          },
          backgroundColor: 'rgba(50, 50, 50, 0.9)',
          borderColor: '#333',
          textStyle: {
            color: '#fff',
            fontSize: 12
          }
        },
        series: [
          {
            type: 'sankey',
            layout: 'none',
            emphasis: {
              focus: 'adjacency',
              blurScope: 'coordinateSystem',
              itemStyle: {
                shadowBlur: 10,
                shadowColor: 'rgba(0,0,0,0.4)',
                borderWidth: 2,
                borderColor: '#333'
              },
              lineStyle: {
                opacity: 1,
                width: 6
              },
              label: {
                color: '#000',
                fontWeight: 'bold',
                fontSize: 12
              }
            },
            blur: {
              itemStyle: {
                opacity: 0.15  // 大幅降低非高亮区域的透明度
              },
              lineStyle: {
                opacity: 0.1   // 大幅降低非高亮连线的透明度
              },
              label: {
                opacity: 0.3   // 降低非高亮标签的透明度
              }
            },
            select: {
              itemStyle: {
                borderColor: '#333'
              }
            },
            nodeAlign: 'justify', // 恢复justify对齐，确保第一层分布正确
            nodeGap: this.calculateNodeGap(), // 恢复动态计算节点间距
            nodeWidth: this.calculateNodeWidth(), // 动态计算节点宽度
            draggable: false, // 禁用拖拽，防止位置被改变
            focusNodeAdjacency: 'allEdges',
            layoutIterations: this.sortEnabled ? 0 : 32, // 根据排序开关控制布局迭代次数
            nodeSort: this.sortEnabled ? false : null, // 排序开关控制ECharts自动排序
            left: '3%',
            right: '10%',
            top: '3%',
            bottom: '3%',
            // 尝试使用levels配置来影响层级布局
            levels: this.calculateLevelsConfig(),
            data: this.sankeyData.nodes.map(node => ({
              ...node,
              label: {
                show: this.showLabels,  // 根据开关控制节点标签显示
                position: 'right',
                formatter: (params) => {
                  return this.removeNodePrefix(params.name)
                },
                fontSize: 11,
                color: '#333'
              }
            })),
            links: this.sankeyData.links,
            lineStyle: {
              color: 'gradient',
              curveness: 0.5,
              opacity: 0.7
            },
            itemStyle: {
              borderWidth: 1,
              borderColor: '#fff',
              shadowBlur: 2,
              shadowColor: 'rgba(0,0,0,0.2)'
            }
          }
        ]
      }
      
      // 最终确认：显示传递给ECharts的节点顺序
      console.log('传递给ECharts的最终节点顺序:')
      if (this.sankeyData && this.sankeyData.nodes) {
        const finalLayer1 = this.sankeyData.nodes.filter(n => n.category === 0)
        const finalLayer2 = this.sankeyData.nodes.filter(n => n.category === 1) 
        const finalLayer3 = this.sankeyData.nodes.filter(n => n.category === 2)
        console.log('最终第一层:', finalLayer1.map(n => `${n.name}(y:${n.y?.toFixed(3)})`))
        console.log('最终第二层:', finalLayer2.map(n => `${n.name}(y:${n.y?.toFixed(3)})`))
        console.log('最终第三层:', finalLayer3.map(n => `${n.name}(y:${n.y?.toFixed(3)})`))
      }
      
      this.sankeyChart.setOption(option, true)
      
      // 接受ECharts的默认布局，专注于用户体验优化
      
      // 添加鼠标悬停和点击事件处理
      this.sankeyChart.off('mouseover')
      this.sankeyChart.off('mouseout')
      this.sankeyChart.off('click')
      
      this.sankeyChart.on('mouseover', (params) => {
        if (!this.isClickHighlighted) {
          if (params.dataType === 'node') {
            this.highlightNodePath(params.data.name)
          } else if (params.dataType === 'edge') {
            this.highlightEdgePath(params.data)
          }
        }
      })
      
      this.sankeyChart.on('mouseout', () => {
        if (!this.isClickHighlighted) {
          this.clearHighlight()
        }
      })
      
      // 点击事件 - 保持高亮效果
      this.sankeyChart.on('click', (params) => {
        if (params.dataType === 'node') {
          this.clickedNode = params.data.name
          this.isClickHighlighted = true
          this.highlightNodePath(params.data.name)
        } else if (params.dataType === 'edge') {
          this.clickedNode = `${params.data.source}-${params.data.target}`
          this.isClickHighlighted = true
          this.highlightEdgePath(params.data)
        }
      })
      
      // 点击空白区域取消高亮
      this.sankeyChart.getZr().on('click', (params) => {
        if (!params.target) {
          this.clearClickHighlight()
        }
      })
    },
    
    // 加载下拉选项数据
    async loadOptions() {
      try {
        const response = await request({
          url: '/api/wrong-analysis/options',
          method: 'get'
        })
        
        if (response.code === 200) {
          const data = response.data
          
          // 处理标签选项
          this.tagOptions = data.tags.map(tag => ({
            value: tag,
            label: tag
          }))
          
          // 处理难度选项
          this.levelOptions = data.levels.map(level => ({
            value: level,
            label: level
          }))
          
          // 处理错误类型选项
          this.errorOptions = data.errors.map(error => ({
            value: error,
            label: error
          }))
        }
      } catch (error) {
        console.error('加载选项数据失败:', error)
      }
    },
    
    // 查询数据
    async handleQuery() {
      this.loading = true
      this.chartLoading = true
      
      try {
        const params = {}
        
        // 处理数组参数，添加[]后缀
        if (this.queryForm.tagNames && this.queryForm.tagNames.length > 0) {
          params['tagNames[]'] = this.queryForm.tagNames
        }
        if (this.queryForm.questionLevels && this.queryForm.questionLevels.length > 0) {
          params['questionLevels[]'] = this.queryForm.questionLevels
        }
        if (this.queryForm.errorNames && this.queryForm.errorNames.length > 0) {
          params['errorNames[]'] = this.queryForm.errorNames
        }
        if (this.queryForm.dateRange && this.queryForm.dateRange.length > 0) {
          params['dateRange[]'] = this.queryForm.dateRange
        }
        
        params.chartType = this.chartType ? 'time' : 'tag'
        
        const response = await request({
          url: '/api/wrong-analysis/data',
          method: 'get',
          params
        })
        
        if (response.code === 200) {
          const data = response.data
          
          // 更新桑基图数据
          const sankeyData = data.sankeyData || { nodes: [], links: [], completePaths: [] }
          
          // 对所有节点进行排序优化
          if (sankeyData.nodes.length > 0) {
            if (this.chartType) {
              sankeyData.nodes = this.sortTimeNodes(sankeyData.nodes)
            } else {
              sankeyData.nodes = this.sortTagNodes(sankeyData.nodes)
            }
            sankeyData.nodes = this.sortAllLayerNodes(sankeyData.nodes)
          }
          
          this.sankeyData = {
            nodes: sankeyData.nodes,
            links: sankeyData.links,
            completePaths: sankeyData.completePaths
          }
          
          // 更新统计数据
          this.statisticsData = data.statistics || {}
          
          // 强制更新图表高度
          this.$nextTick(() => {
            this.chartHeight = this.dynamicChartHeight
            this.$nextTick(() => {
              // 更新图表
              this.updateChart()
              // 确保图表大小调整
              if (this.sankeyChart) {
                this.sankeyChart.resize()
              }
            })
          })
        } else {
          this.$message.error(response.message || '获取数据失败')
        }
      } catch (error) {
        console.error('查询数据失败:', error)
        this.$message.error('查询失败，请稍后重试')
      } finally {
        this.loading = false
        this.chartLoading = false
      }
    },
    
    // 重置查询条件
    handleReset() {
      this.queryForm = {
        tagNames: [],
        questionLevels: [],
        errorNames: [],
        dateRange: []
      }
      this.handleQuery()
    },
    
    // 切换图表类型
    handleChartTypeChange() {
      this.handleQuery()
    },
    
    // 切换排序模式
    handleSortToggle() {
      this.updateChart()
    },
    
    // 切换标签显示
    handleLabelToggle() {
      // 如果从隐藏切换到显示，需要清除当前的高亮状态
      if (this.showLabels && this.isClickHighlighted) {
        this.clearClickHighlight()
      }
      this.updateChart()
    },
    
    
    // 下载图表图片
    async downloadChart() {
      if (!this.sankeyChart) {
        this.$message.warning('图表未加载完成，请稍后再试')
        return
      }
      
      this.downloadLoading = true
      
      try {
        // 获取图表的base64图片数据
        const imgData = this.sankeyChart.getDataURL({
          type: 'png',
          pixelRatio: 2, // 高清图片
          backgroundColor: '#ffffff'
        })
        
        // 创建下载链接
        const link = document.createElement('a')
        const fileName = `错题分析_${this.chartType ? '时间维度' : '标签维度'}_${new Date().toISOString().slice(0, 10)}.png`
        
        link.href = imgData
        link.download = fileName
        link.style.display = 'none'
        
        // 触发下载
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        
        this.$message.success('图片下载成功')
      } catch (error) {
        console.error('下载图片失败:', error)
        this.$message.error('下载失败，请稍后重试')
      } finally {
        this.downloadLoading = false
      }
    },
    
    // 获取难度颜色
    getDifficultyColor(level) {
      const colorMap = {
        '红题': '#F56C6C',
        '橙题': '#E6A23C', 
        '黄题': '#F7BA2A',
        '绿题': '#67C23A',
        '蓝题': '#409EFF',
        '紫题': '#8E44AD',
        '黑题': '#2C3E50',
        '未定义': '#909399'
      }
      return colorMap[level] || '#909399'
    },
    
    
    // 窗口大小变化处理
    handleResize() {
      if (this.sankeyChart) {
        this.sankeyChart.resize()
      }
    },
    
    // 动态计算节点间距 - 时间维度紧凑优化
    calculateNodeGap() {
      const nodeCount = this.sankeyData.nodes.length
      const layer1Count = this.sankeyData.nodes.filter(n => n.category === 0).length
      const availableHeight = this.chartHeight - 180  // 与新的边距保持一致
      
      // 如果是时间维度，基于可用高度和节点数量精确计算间距
      if (this.chartType) {
        // 预留上下边距（10%）
        const reservedMargin = availableHeight * 0.1
        const usableHeight = availableHeight - reservedMargin
        
        // 根据节点数量计算理想间距
        const idealGap = Math.floor(usableHeight / Math.max(layer1Count, 1))
        
        // 设置合理的间距范围
        const minGap = 8   // 最小间距，防止节点重叠
        const maxGap = 35  // 最大间距，防止过于稀疏
        
        return Math.min(Math.max(idealGap, minGap), maxGap)
      } else {
        // 标签维度使用调整后的逻辑
        if (nodeCount <= 8) {
          return 32  // 稍微减少（原35）
        } else if (nodeCount <= 15) {
          return 23  // 稍微减少（原25）
        } else if (nodeCount <= 25) {
          return 16  // 稍微减少（原18）
        } else if (nodeCount <= 40) {
          return 12
        } else {
          const minGap = 10
          const calculatedGap = Math.floor(availableHeight / nodeCount * 0.4)
          return Math.max(minGap, calculatedGap)
        }
      }
    },
    
    // 动态计算节点宽度
    calculateNodeWidth() {
      const nodeCount = this.sankeyData.nodes.length
      
      if (nodeCount <= 10) {
        return 20
      } else if (nodeCount <= 20) {
        return 18
      } else if (nodeCount <= 40) {
        return 15
      } else {
        return 12 // 节点很多时使用较小宽度
      }
    },
    
    // 计算动态顶部位置
    calculateDynamicTop() {
      if (!this.sankeyData || !this.sankeyData.nodes) return '2%'
      
      const layer1Count = this.sankeyData.nodes.filter(node => node.category === 0).length
      
      // 如果第一层节点很多，增加顶部空间来推动第二三层向下
      if (layer1Count > 15) {
        return '8%'  // 增加顶部空间
      } else if (layer1Count > 8) {
        return '5%'  
      } else {
        return '3%'   
      }
    },
    
    // 计算动态底部位置
    calculateDynamicBottom() {
      if (!this.sankeyData || !this.sankeyData.nodes) return '2%'
      
      const layer1Count = this.sankeyData.nodes.filter(node => node.category === 0).length
      
      // 第一层节点多时，减少底部空间，让整体向下移
      if (layer1Count > 15) {
        return '2%'  
      } else {
        return '3%'   
      }
    },
    
    // 计算levels配置，尝试影响层级分布
    calculateLevelsConfig() {
      if (!this.sankeyData || !this.sankeyData.nodes) return []
      
      const layer1Count = this.sankeyData.nodes.filter(node => node.category === 0).length
      const layer2Count = this.sankeyData.nodes.filter(node => node.category === 1).length
      const layer3Count = this.sankeyData.nodes.filter(node => node.category === 2).length
      
      // 基于节点数量动态调整每层的配置
      return [
        {
          depth: 0,
          itemStyle: {
            opacity: 0.8
          },
          // 第一层占用的垂直空间比例
          nodeGap: this.calculateNodeGap()
        },
        {
          depth: 1, 
          itemStyle: {
            opacity: 0.9
          },
          // 尝试通过不同的nodeGap影响第二层分布
          nodeGap: Math.max(8, this.calculateNodeGap() * 0.6)
        },
        {
          depth: 2,
          itemStyle: {
            opacity: 1
          },
          // 第三层使用更小的间距
          nodeGap: Math.max(6, this.calculateNodeGap() * 0.4)
        }
      ]
    },
    
    
    
    // 高亮节点的完整路径
    highlightNodePath(nodeName) {
      const relatedNodes = new Set()
      const relatedLinks = new Set()
      
      // 添加当前节点
      relatedNodes.add(nodeName)
      
      // 根据节点类型确定查找策略
      const nodeCategory = this.getNodeCategory(nodeName)
      
      if (nodeCategory === 0) {
        // 第一层节点（标签/时间）-> 查找完整的数据流路径
        this.findCompleteDataPaths(nodeName, relatedNodes, relatedLinks)
      } else if (nodeCategory === 1) {
        // 第二层节点（难度）-> 查找通过该难度的完整路径
        this.findPathsThroughMiddleNode(nodeName, relatedNodes, relatedLinks)
      } else if (nodeCategory === 2) {
        // 第三层节点（错误类型）-> 查找导致该错误的完整路径
        this.findPathsToEndNode(nodeName, relatedNodes, relatedLinks)
      }
      
      // 更新图表，高亮相关元素
      this.updateHighlight(relatedNodes, relatedLinks)
      
      // 显示固定tooltip
      this.showFixedTooltipForNode(nodeName)
    },
    
    // 高亮边的相关路径
    highlightEdgePath(edgeData) {
      const relatedNodes = new Set()
      const relatedLinks = new Set()
      
      // 添加边的源和目标节点
      relatedNodes.add(edgeData.source)
      relatedNodes.add(edgeData.target)
      relatedLinks.add(`${edgeData.source}-${edgeData.target}`)
      
      // 查找同时经过源节点和目标节点的完整路径（AND逻辑）
      this.findPathsThroughSpecificEdge(edgeData.source, edgeData.target, relatedNodes, relatedLinks)
      
      // 更新图表
      this.updateHighlight(relatedNodes, relatedLinks)
      
      // 显示固定tooltip
      this.showFixedTooltipForEdge(edgeData)
    },
    
    // 获取节点分类
    getNodeCategory(nodeName) {
      const node = this.sankeyData.nodes.find(n => n.name === nodeName)
      return node ? node.category : -1
    },
    
    // 向前查找路径（从当前节点到后续节点）
    findForwardPaths(nodeName, relatedNodes, relatedLinks) {
      this.sankeyData.links.forEach(link => {
        if (link.source === nodeName) {
          relatedNodes.add(link.target)
          relatedLinks.add(`${link.source}-${link.target}`)
          // 递归查找下一层
          this.findForwardPaths(link.target, relatedNodes, relatedLinks)
        }
      })
    },
    
    // 向后查找路径（从当前节点到前置节点）
    findBackwardPaths(nodeName, relatedNodes, relatedLinks) {
      this.sankeyData.links.forEach(link => {
        if (link.target === nodeName) {
          relatedNodes.add(link.source)
          relatedLinks.add(`${link.source}-${link.target}`)
          // 递归查找上一层
          this.findBackwardPaths(link.source, relatedNodes, relatedLinks)
        }
      })
    },
    
    // 查找完整的数据流路径（专用于第一层节点）- 使用真实路径数据
    findCompleteDataPaths(startNodeName, relatedNodes, relatedLinks) {
      // 使用后端返回的完整路径信息进行精确查找
      const relatedPaths = this.sankeyData.completePaths.filter(path => 
        path.layer1 === startNodeName
      )
      
      // 添加所有相关路径中的节点和连接
      relatedPaths.forEach(path => {
        // 添加路径中的所有节点
        path.path.forEach(node => {
          relatedNodes.add(node)
        })
        
        // 添加路径中的所有连接
        for (let i = 0; i < path.path.length - 1; i++) {
          relatedLinks.add(`${path.path[i]}-${path.path[i + 1]}`)
        }
      })
    },
    
    // 查找通过中间节点（难度）的完整路径
    findPathsThroughMiddleNode(middleNodeName, relatedNodes, relatedLinks) {
      const relatedPaths = this.sankeyData.completePaths.filter(path => 
        path.layer2 === middleNodeName
      )
      
      relatedPaths.forEach(path => {
        path.path.forEach(node => {
          relatedNodes.add(node)
        })
        
        for (let i = 0; i < path.path.length - 1; i++) {
          relatedLinks.add(`${path.path[i]}-${path.path[i + 1]}`)
        }
      })
    },
    
    // 查找导致末端节点（错误类型）的完整路径
    findPathsToEndNode(endNodeName, relatedNodes, relatedLinks) {
      const relatedPaths = this.sankeyData.completePaths.filter(path => 
        path.layer3 === endNodeName
      )
      
      relatedPaths.forEach(path => {
        path.path.forEach(node => {
          relatedNodes.add(node)
        })
        
        for (let i = 0; i < path.path.length - 1; i++) {
          relatedLinks.add(`${path.path[i]}-${path.path[i + 1]}`)
        }
      })
    },
    
    // 查找同时经过特定边（源节点->目标节点）的完整路径
    findPathsThroughSpecificEdge(sourceNodeName, targetNodeName, relatedNodes, relatedLinks) {
      // 使用completePaths数据查找同时包含源节点和目标节点的路径
      const relatedPaths = this.sankeyData.completePaths.filter(path => {
        // 检查路径中是否包含源节点和目标节点，并且它们是相邻的
        const pathNodes = path.path
        for (let i = 0; i < pathNodes.length - 1; i++) {
          if (pathNodes[i] === sourceNodeName && pathNodes[i + 1] === targetNodeName) {
            return true
          }
        }
        return false
      })
      
      // 添加所有相关路径中的节点和连接
      relatedPaths.forEach(path => {
        // 添加路径中的所有节点
        path.path.forEach(node => {
          relatedNodes.add(node)
        })
        
        // 添加路径中的所有连接
        for (let i = 0; i < path.path.length - 1; i++) {
          relatedLinks.add(`${path.path[i]}-${path.path[i + 1]}`)
        }
      })
    },
    
    // 更新高亮效果
    updateHighlight(relatedNodes, relatedLinks) {
      const option = this.sankeyChart.getOption()
      const series = option.series[0]
      
      // 处理节点高亮 - 更强的对比度
      series.data = this.sankeyData.nodes.map(node => ({
        ...node,
        itemStyle: {
          ...node.itemStyle,
          opacity: relatedNodes.has(node.name) ? 1 : 0.15,  // 更低的非高亮透明度
          shadowBlur: relatedNodes.has(node.name) ? 8 : 0,
          shadowColor: relatedNodes.has(node.name) ? 'rgba(0,0,0,0.3)' : 'transparent'
        },
        label: {
          ...node.label,
          show: this.showLabels || relatedNodes.has(node.name), // 显示开关开启时显示所有，关闭时只显示高亮节点
          formatter: (params) => {
            return this.removeNodePrefix(params.name)
          },
          color: relatedNodes.has(node.name) ? '#000' : '#999',
          fontWeight: relatedNodes.has(node.name) ? 'bold' : 'normal',
          opacity: relatedNodes.has(node.name) ? 1 : 0.3
        }
      }))
      
      // 处理连线高亮 - 更强的对比度
      series.links = this.sankeyData.links.map(link => ({
        ...link,
        lineStyle: {
          opacity: relatedLinks.has(`${link.source}-${link.target}`) ? 0.9 : 0.1,  // 更低的非高亮透明度
          color: 'gradient',
          width: relatedLinks.has(`${link.source}-${link.target}`) ? 5 : undefined
        }
      }))
      
      this.sankeyChart.setOption(option)
    },
    
    // 清除高亮效果
    clearHighlight() {
      const option = this.sankeyChart.getOption()
      const series = option.series[0]
      
      // 恢复所有节点的正常状态
      series.data = this.sankeyData.nodes.map(node => ({
        ...node,
        itemStyle: {
          ...node.itemStyle,
          opacity: 1
        },
        label: {
          ...node.label,
          show: this.showLabels, // 根据开关状态恢复标签显示
          formatter: (params) => {
            return this.removeNodePrefix(params.name)
          },
          color: '#333'
        }
      }))
      
      // 恢复所有连线的正常状态
      series.links = this.sankeyData.links.map(link => ({
        ...link,
        lineStyle: {
          opacity: 0.7,
          color: 'gradient'
        }
      }))
      
      this.sankeyChart.setOption(option)
      
      // 关闭固定tooltip
      this.closeFixedTooltip()
    },
    
    // 清除点击高亮
    clearClickHighlight() {
      this.clickedNode = null
      this.isClickHighlighted = false
      this.clearHighlight()
    },
    
    // 判断是否需要显示tooltip
    needsTooltip(text) {
      if (!text || text === '-') return false
      return text.length > 12 // 超过12个字符显示tooltip
    },
    
    // 对时间节点进行重新排序
    sortTimeNodes(nodes) {
      const timeNodes = []
      const otherNodes = []
      
      // 分离时间节点和其他节点
      nodes.forEach(node => {
        if (node.name && node.name.startsWith('时间_')) {
          timeNodes.push(node)
        } else {
          otherNodes.push(node)
        }
      })
      
      // 对时间节点按时间降序排序
      timeNodes.sort((a, b) => {
        const timeA = a.name.replace('时间_', '')
        const timeB = b.name.replace('时间_', '')
        
        try {
          const [yearA, monthA] = timeA.split('/').map(x => parseInt(x))
          const [yearB, monthB] = timeB.split('/').map(x => parseInt(x))
          
          if (yearA !== yearB) {
            return yearB - yearA // 年份降序
          }
          return monthB - monthA // 月份降序
        } catch {
          return timeB.localeCompare(timeA)
        }
      })
      
      // y坐标会在后续的redistributeNodePositions中设置，这里不需要设置
      
      return [...timeNodes, ...otherNodes]
    },
    
    // 对标签节点进行排序
    sortTagNodes(nodes) {
      const tagNodes = []
      const otherNodes = []
      
      // 分离标签节点和其他节点
      nodes.forEach(node => {
        if (node.name && node.name.startsWith('标签_')) {
          tagNodes.push(node)
        } else {
          otherNodes.push(node)
        }
      })
      
      // 对标签节点按名称排序
      tagNodes.sort((a, b) => {
        const tagA = a.name.replace('标签_', '').toLowerCase()
        const tagB = b.name.replace('标签_', '').toLowerCase()
        return tagA.localeCompare(tagB)
      })
      
      return [...tagNodes, ...otherNodes]
    },
    
    // 对所有层级节点进行综合排序和位置优化
    sortAllLayerNodes(nodes) {
      const layer1Nodes = []  // 第一层（时间/标签）
      const layer2Nodes = []  // 第二层（难度）
      const layer3Nodes = []  // 第三层（错误类型）
      
      // 按类别分组
      nodes.forEach(node => {
        if (node.category === 0) {
          layer1Nodes.push(node)
        } else if (node.category === 1) {
          layer2Nodes.push(node)
        } else if (node.category === 2) {
          layer3Nodes.push(node)
        }
      })
      
      // 第一层排序（已在其他方法中处理）
      if (this.chartType) {
        // 时间维度：按时间降序，并设置排序索引以影响ECharts布局
        layer1Nodes.sort((a, b) => {
          const timeA = a.name.replace('时间_', '')
          const timeB = b.name.replace('时间_', '')
          try {
            const [yearA, monthA] = timeA.split('/').map(x => parseInt(x))
            const [yearB, monthB] = timeB.split('/').map(x => parseInt(x))
            if (yearA !== yearB) return yearB - yearA
            return monthB - monthA
          } catch {
            return timeB.localeCompare(timeA)
          }
        })
        
        // 为时间节点设置排序索引，帮助ECharts自动布局
        layer1Nodes.forEach((node, index) => {
          node.sortIndex = index  // 添加排序索引
        })
      } else {
        // 标签维度：直接按字符串排序（01-xxx, 02-xxx, ..., 12-xxx, 13-xxx, 未定义）
        layer1Nodes.sort((a, b) => {
          const tagA = a.name.replace('标签_', '')
          const tagB = b.name.replace('标签_', '')
          return tagA.localeCompare(tagB)
        })
      }
      
      // 第二层（难度）按标准顺序排序
      // 支持多种难度命名格式
      const difficultyOrder = [
        '红题', '橙题', '黄题', '绿题', '蓝题', '紫题', '黑题',
        '入门', '简单', '中等', '困难', '竞赛',
        '未定义'
      ]
      
      console.log('难度节点排序前:', layer2Nodes.map(n => n.name))
      
      layer2Nodes.sort((a, b) => {
        const levelA = a.name.replace('难度_', '')
        const levelB = b.name.replace('难度_', '')
        const indexA = difficultyOrder.indexOf(levelA)
        const indexB = difficultyOrder.indexOf(levelB)
        
        console.log(`难度排序: ${levelA}(${indexA}) vs ${levelB}(${indexB})`)
        
        return (indexA === -1 ? 99 : indexA) - (indexB === -1 ? 99 : indexB)
      })
      
      console.log('难度节点排序后:', layer2Nodes.map(n => n.name))
      
      // 第三层（错误类型）按重要性排序 - 完整的10种错误类型
      const errorOrder = [
        '1-算法未掌握', 
        '2-思路/逻辑偏差', 
        '3-实现/细节错误', 
        '4-效率/复杂度问题', 
        '5-边界/特殊情况遗漏',
        '6-题意理解偏差',
        '7-工具/环境问题',
        '8-心理性错误',
        '9-其他/暂未分类错误',
        '未定义'
      ]
      
      console.log('错误类型节点排序前:', layer3Nodes.map(n => n.name))
      
      layer3Nodes.sort((a, b) => {
        const errorA = a.name.replace('错误_', '')
        const errorB = b.name.replace('错误_', '')
        const indexA = errorOrder.indexOf(errorA)
        const indexB = errorOrder.indexOf(errorB)
        
        console.log(`错误类型排序: ${errorA}(${indexA}) vs ${errorB}(${indexB})`)
        
        return (indexA === -1 ? 99 : indexA) - (indexB === -1 ? 99 : indexB)
      })
      
      console.log('错误类型节点排序后:', layer3Nodes.map(n => n.name))
      
      // 重新计算位置，实现防遮盖和居中
      this.redistributeNodePositions(layer1Nodes, layer2Nodes, layer3Nodes)
      
      return [...layer1Nodes, ...layer2Nodes, ...layer3Nodes]
    },
    
    // 结合排序和levels布局：给节点智能的初始位置，让ECharts优化布局
    redistributeNodePositions(layer1Nodes, layer2Nodes, layer3Nodes) {
      // 排序已在sortAllLayerNodes中完成，现在设置引导性的初始位置
      
      // 如果禁用排序模式，不设置任何位置，让ECharts完全自动布局
      if (!this.sortEnabled) {
        return
      }
      
      // 计算第一层的分布重心
      const layer1Count = layer1Nodes.length
      let layer1Center = 0.5
      
      // 第一层：时间或标签（确保所有维度都有明确排序位置）
      if (layer1Nodes.length > 0) {
        layer1Nodes.forEach((node, index) => {
          if (layer1Nodes.length > 1) {
            let margin = this.chartType ? 0.08 : 0.05
            if (layer1Nodes.length > 10) {
              margin = this.chartType ? 0.12 : 0.08
            } else if (layer1Nodes.length > 20) {
              margin = this.chartType ? 0.15 : 0.1
            }
            const availableRange = 1 - 2 * margin
            node.y = margin + (index / (layer1Nodes.length - 1)) * availableRange
          } else {
            node.y = 0.5
          }
          // 设置强制排序标记
          node.sortIndex = index
          node.fixed = true   // 强制固定位置，防止ECharts修改
          node.draggable = false
          node.depth = 0      // 确保深度正确
        })
        
        // 计算第一层的重心位置
        layer1Center = layer1Nodes.reduce((sum, node) => sum + node.y, 0) / layer1Nodes.length
      }
      
      // 第二层：难度（给一个向下偏移的初始位置）
      if (layer2Nodes.length > 0) {
        // 基于第一层重心计算偏移
        let centerShift = 0
        if (layer1Count > 15) {
          centerShift = 0.15  // 第一层很多时，第二层向下偏移更多
        } else if (layer1Count > 8) {
          centerShift = 0.1   // 中等偏移
        } else {
          centerShift = 0.05  // 小幅偏移
        }
        
        const targetCenter = Math.min(0.8, layer1Center + centerShift)
        
        layer2Nodes.forEach((node, index) => {
          if (layer2Nodes.length > 1) {
            // 围绕目标中心分布，确保排序间距
            const spreadRange = Math.min(0.4, layer2Nodes.length * 0.06)
            const offset = targetCenter - spreadRange / 2
            node.y = offset + (index / (layer2Nodes.length - 1)) * spreadRange
          } else {
            node.y = targetCenter
          }
          // 强制排序标记
          node.sortIndex = index
          node.fixed = true   // 强制固定位置，防止ECharts修改
          node.draggable = false
          node.depth = 1      // 确保深度正确
        })
      }
      
      // 第三层：错误类型（再向下偏移一些）
      if (layer3Nodes.length > 0) {
        // 基于第二层或第一层计算偏移
        let baseCenter = layer1Center
        if (layer2Nodes.length > 0) {
          baseCenter = layer2Nodes.reduce((sum, node) => sum + node.y, 0) / layer2Nodes.length
        }
        
        let centerShift = 0
        if (layer1Count > 15) {
          centerShift = 0.1   // 继续向下
        } else if (layer1Count > 8) {
          centerShift = 0.08  
        } else {
          centerShift = 0.05  
        }
        
        const targetCenter = Math.min(0.85, baseCenter + centerShift)
        
        layer3Nodes.forEach((node, index) => {
          if (layer3Nodes.length > 1) {
            // 围绕目标中心分布，确保排序间距
            const spreadRange = Math.min(0.35, layer3Nodes.length * 0.05)
            const offset = targetCenter - spreadRange / 2
            node.y = offset + (index / (layer3Nodes.length - 1)) * spreadRange
          } else {
            node.y = targetCenter
          }
          // 强制排序标记
          node.sortIndex = index
          node.fixed = true   // 强制固定位置，防止ECharts修改
          node.draggable = false
          node.depth = 2      // 确保深度正确
        })
      }
      
      console.log('位置引导完成 - 第一层重心:', layer1Center.toFixed(3), 
                  '第二层节点数:', layer2Nodes.length, 
                  '第三层节点数:', layer3Nodes.length)
      
      // 调试：显示最终的节点位置分配
      console.log('最终节点位置:')
      console.log('第一层:', layer1Nodes.map((n, i) => `${n.name}(${i}):${n.y?.toFixed(3)}`))
      console.log('第二层:', layer2Nodes.map((n, i) => `${n.name}(${i}):${n.y?.toFixed(3)}`))
      console.log('第三层:', layer3Nodes.map((n, i) => `${n.name}(${i}):${n.y?.toFixed(3)}`))
    },
    
    // 显示节点的固定tooltip
    showFixedTooltipForNode(nodeName) {
      const node = this.sankeyData.nodes.find(n => n.name === nodeName)
      if (!node) return
      
      // 计算tooltip内容
      const displayName = this.removeNodePrefix(nodeName)
      const title = `节点详情: ${displayName}`
      const content = this.generateNodeTooltipContent(node)
      
      // 计算智能位置
      const position = this.calculateTooltipPosition(node, 'node')
      
      // 显示tooltip
      this.fixedTooltip = {
        visible: true,
        title: title,
        content: content,
        x: position.x,
        y: position.y,
        isDragging: false,
        dragOffset: { x: 0, y: 0 }
      }
    },
    
    // 显示边的固定tooltip
    showFixedTooltipForEdge(edgeData) {
      // 计算tooltip内容
      const sourceName = this.removeNodePrefix(edgeData.source)
      const targetName = this.removeNodePrefix(edgeData.target)
      const title = `管道详情: ${sourceName} → ${targetName}`
      const content = this.generateEdgeTooltipContent(edgeData)
      
      // 计算智能位置
      const position = this.calculateTooltipPosition(edgeData, 'edge')
      
      // 显示tooltip
      this.fixedTooltip = {
        visible: true,
        title: title,
        content: content,
        x: position.x,
        y: position.y,
        isDragging: false,
        dragOffset: { x: 0, y: 0 }
      }
    },
    
    // 生成节点tooltip内容
    generateNodeTooltipContent(node) {
      const categoryName = ['标签/时间', '难度', '错误类型'][node.category] || '未知'
      const displayName = this.removeNodePrefix(node.name)
      return `
      <div class="tooltip-info">
        <p style="margin-top: 2px; margin-bottom: 2px;"><i class="el-icon-collection-tag" style="color: #409eff; font-weight: bold;"></i> <strong>类型:</strong> ${categoryName}</p>
        <p style="margin-top: 2px; margin-bottom: 2px;"><i class="el-icon-user" style="color: #409eff; font-weight: bold;"></i> <strong>名称:</strong> ${displayName}</p>
        <p style="margin-top: 2px; margin-bottom: 2px;"><i class="el-icon-data-line" style="color: #409eff; font-weight: bold;"></i> <strong>数值:</strong> ${node.value || 0}</p>
        <p style="margin-top: 2px; margin-bottom: 2px;"><i class="el-icon-menu" style="color: #409eff; font-weight: bold;"></i> <strong>层级:</strong> 第${node.category + 1}层</p>
      </div>
      `
    },
    
    // 生成边tooltip内容
    generateEdgeTooltipContent(edgeData) {
      const sourceName = this.removeNodePrefix(edgeData.source)
      const targetName = this.removeNodePrefix(edgeData.target)
      return `
      <div class="tooltip-info">
        <p style="margin-top: 2px; margin-bottom: 2px;"><i class="el-icon-s-promotion" style="color: #409eff; font-weight: bold;"></i> <strong>源节点:</strong> ${sourceName}</p>
        <p style="margin-top: 2px; margin-bottom: 2px;"><i class="el-icon-s-check" style="color: #409eff; font-weight: bold;"></i> <strong>目标节点:</strong> ${targetName}</p>
        <p style="margin-top: 2px; margin-bottom: 2px;"><i class="el-icon-loading" style="color: #409eff; font-weight: bold;"></i> <strong>流量:</strong> ${edgeData.value || 0}</p>
        <p style="margin-top: 2px; margin-bottom: 2px;"><i class="el-icon-connection" style="color: #409eff; font-weight: bold;"></i> <strong>关系:</strong> 数据流向</p>
      </div>
      `
    },
    
    // 计算tooltip的智能位置
    calculateTooltipPosition(targetData, type) {
      const chartContainer = this.$refs.sankeyChart
      if (!chartContainer) return { x: 100, y: 100 }
      
      const containerRect = chartContainer.getBoundingClientRect()
      const tooltipWidth = 280
      const tooltipHeight = 200
      
      // 默认位置：右上角
      let x = containerRect.right - tooltipWidth - 20
      let y = containerRect.top + 20
      
      // 如果右边空间不够，放到左边
      if (x < containerRect.left) {
        x = containerRect.left + 20
      }
      
      // 如果上边空间不够，放到下面
      if (y + tooltipHeight > containerRect.bottom) {
        y = containerRect.bottom - tooltipHeight - 20
      }
      
      // 确保不超出视窗
      x = Math.max(20, Math.min(x, window.innerWidth - tooltipWidth - 20))
      y = Math.max(20, Math.min(y, window.innerHeight - tooltipHeight - 20))
      
      return { x, y }
    },
    
    // 关闭固定tooltip
    closeFixedTooltip() {
      this.fixedTooltip.visible = false
    },
    
    // tooltip拖拽事件处理
    handleTooltipMouseDown(event) {
      this.fixedTooltip.isDragging = true
      this.fixedTooltip.dragOffset = {
        x: event.clientX - this.fixedTooltip.x,
        y: event.clientY - this.fixedTooltip.y
      }
      event.preventDefault()
    },
    
    handleTooltipMouseMove(event) {
      if (this.fixedTooltip.isDragging) {
        this.fixedTooltip.x = event.clientX - this.fixedTooltip.dragOffset.x
        this.fixedTooltip.y = event.clientY - this.fixedTooltip.dragOffset.y
        
        // 限制在视窗范围内
        this.fixedTooltip.x = Math.max(0, Math.min(this.fixedTooltip.x, window.innerWidth - 280))
        this.fixedTooltip.y = Math.max(0, Math.min(this.fixedTooltip.y, window.innerHeight - 200))
      }
    },
    
    handleTooltipMouseUp() {
      this.fixedTooltip.isDragging = false
    }
  }
}
</script>

<style scoped>
.wrong-analysis {
  padding: 8px 0;
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.header-controls {
  display: flex;
  align-items: center;
  gap: 12px;
}

.header-controls .el-switch {
  margin-right: 8px;
}

.download-btn {
  margin-left: 8px;
}



.query-card {
  margin-bottom: 12px;
}

.query-content {
  padding: 0;
  overflow-x: auto;
  /* 美化滚动条 */
  scrollbar-width: thin;
  scrollbar-color: #c1c1c1 #f1f1f1;
}

.query-content::-webkit-scrollbar {
  height: 6px;
}

.query-content::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 3px;
}

.query-content::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 3px;
}

.query-content::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}

.query-form-single-row {
  display: flex;
  align-items: center;
  gap: 12px;
  min-width: 900px; /* 减小最小宽度，更紧凑 */
  padding: 4px 0;
}

.query-item {
  min-width: 150px;
  flex-shrink: 0;
}

.query-item .el-select,
.query-item .el-date-editor {
  width: 100%;
}


.query-actions {
  display: flex;
  gap: 12px;
  min-width: 140px;
  flex-shrink: 0;
  align-items: center;
  margin-left: 0;
  padding-left: 0;
}

.query-actions .el-button {
  min-width: 60px;
  margin: 0;
}

.chart-card {
  margin-bottom: 20px;
}

.chart-content {
  position: relative;
  padding: 0;
}

.chart-container {
  width: 100%;
  min-height: 400px;  /* 调整为新的基础高度 */
}


.stats-card {
  margin-bottom: 12px;
  border: 1px solid #e4e7ed;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.stats-content {
  padding: 0;
}

.stats-row {
  margin: 0;
}

.stat-item {
  text-align: center;
  padding: 16px 8px;
  background: linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%);
  border-radius: 6px;
  margin: 4px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
  transition: all 0.3s ease;
  min-height: 80px;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.stat-item:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.stat-label {
  font-size: 12px;
  color: #909399;
  margin-bottom: 6px;
  font-weight: 500;
  line-height: 1.3;
}

.stat-value {
  font-size: 20px;
  font-weight: 700;
  color: #303133;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
  line-height: 1.2;
  word-break: break-all;
  overflow-wrap: break-word;
  max-height: 48px;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
}

/* 响应式设计 */
@media (max-width: 1200px) {
  .query-form-single-row {
    min-width: 750px; /* 在中等屏幕上稍微减少宽度 */
  }
  
  .query-item {
    min-width: 130px;
  }
}

@media (max-width: 768px) {
  .stats-row .el-col {
    margin-bottom: 16px;
  }
  
  .query-form-single-row {
    min-width: 650px; /* 在小屏幕上进一步减少但保持滚动 */
  }
  
  .query-item {
    min-width: 120px;
  }
  
  .stat-item {
    padding: 12px 6px;
    margin: 3px;
    min-height: 70px;
  }
  
  .stat-value {
    font-size: 18px;
    max-height: 36px;
  }
}

/* 固定tooltip样式 - 精简版本 */
.fixed-tooltip {
  position: fixed;
  z-index: 9999;
  background: rgba(50, 50, 50, 0.95);
  color: white;
  border-radius: 6px;
  box-shadow: 0 3px 8px rgba(0, 0, 0, 0.3);
  min-width: 220px;
  max-width: 300px;
  backdrop-filter: blur(8px);
  border: 1px solid rgba(255, 255, 255, 0.1);
  user-select: none;
}

.tooltip-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 12px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  cursor: move;
}

.tooltip-title {
  font-weight: 500;
  font-size: 13px;
  color: #fff;
}

.tooltip-close {
  cursor: pointer;
  font-size: 14px;
  color: #ccc;
  transition: color 0.2s;
  padding: 2px;
  min-width: 18px;
  min-height: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.tooltip-close:hover {
  color: #fff;
}

.tooltip-content {
  padding: 10px 12px;
  font-size: 12px;
  line-height: 1.4;
}

.tooltip-info p {
  margin: 4px 0;
  color: #e0e0e0;
}

.tooltip-info p i {
  color: #409eff;
  margin-right: 6px;
  font-size: 13px;
  width: 14px;
  display: inline-block;
}

.tooltip-info strong {
  color: #fff;
  font-weight: 500;
}

.tooltip-drag-hint {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 6px 12px;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  font-size: 10px;
  color: #999;
  cursor: move;
}

.tooltip-drag-hint i {
  margin-right: 3px;
  font-size: 10px;
}

.fixed-tooltip:hover .tooltip-drag-hint {
  color: #ccc;
}

/* 错误类型tooltip样式（与Wrongbook.vue保持一致） */
.difficulty-tooltip {
  max-width: 600px !important;
  padding: 0 !important;
  border-radius: 6px !important;
}

.difficulty-tooltip-content {
  max-height: none;
  overflow-y: visible;
  padding: 0;
}

.difficulty-description {
  margin: 0;
  line-height: 1.6;
  font-size: 13px;
}

.difficulty-description p {
  margin: 8px 0;
  color: #ffffff;
}

.difficulty-description p strong {
  color: #409EFF;
  font-weight: 600;
}

.difficulty-description ul {
  margin: 4px 0 8px 0;
  padding-left: 16px;
}

.difficulty-description li {
  margin: 2px 0;
  color: #e6e6e6;
  font-size: 12px;
}
</style>